import React from 'react';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="border-t border-gray-200 bg-white">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 px-4 py-10 sm:grid-cols-2 sm:px-6 lg:grid-cols-4">
        <div>
          <h5 className="mb-3 text-sm font-bold text-gray-900">About Us</h5>
          <p className="text-sm text-gray-500">
            We are dedicated to providing quality products and exceptional service to our customers.
          </p>
        </div>
        <div>
          <h5 className="mb-3 text-sm font-bold text-gray-900">Quick Links</h5>
          <ul className="space-y-2 text-sm text-gray-500">
            <li><a href="/" className="hover:text-brand-700">Home</a></li>
            <li><a href="/products" className="hover:text-brand-700">Products</a></li>
            <li><a href="/wishlist" className="hover:text-brand-700">Wishlist</a></li>
            <li><a href="/about" className="hover:text-brand-700">About</a></li>
          </ul>
        </div>
        <div>
          <h5 className="mb-3 text-sm font-bold text-gray-900">Contact Us</h5>
          <p className="text-sm text-gray-500">Email: contact@example.com</p>
          <p className="text-sm text-gray-500">Phone: 123-456-7890</p>
          <p className="text-sm text-gray-500">Address: 123 Street, City, Country</p>
        </div>
        <div>
          <h5 className="mb-3 text-sm font-bold text-gray-900">Newsletter</h5>
          <p className="mb-3 text-sm text-gray-500">Subscribe to receive updates on new products and special offers.</p>
          <form className="flex gap-2" onSubmit={(e) => e.preventDefault()}>
            <input
              type="email"
              placeholder="Your email address"
              className="min-w-0 flex-1 rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-brand-500 focus:outline-none"
            />
            <button className="shrink-0 rounded-lg bg-brand-600 px-3 py-2 text-sm font-medium text-white hover:bg-brand-700">
              Subscribe
            </button>
          </form>
        </div>
      </div>

      <div className="border-t border-gray-100 px-4 py-6 sm:px-6">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 sm:flex-row">
          <p className="text-xs text-gray-400">&copy; {new Date().getFullYear()} ShopSmart. All Rights Reserved.</p>
          <div className="flex gap-4 text-gray-400">
            <a href="#top" className="hover:text-brand-700"><FaFacebook /></a>
            <a href="#top" className="hover:text-brand-700"><FaTwitter /></a>
            <a href="#top" className="hover:text-brand-700"><FaInstagram /></a>
            <a href="#top" className="hover:text-brand-700"><FaLinkedin /></a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
